'use client'

import { BackdropLoading } from '@/components/backdrop-loading'
import { forgotPassword } from '@/lib/api/auth/auth'
import { ReactFormState, useFormState } from '@/lib/form-state/react-form-state'
import { useAuth } from '@/store/hooks'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { MdCheckCircle } from 'react-icons/md'
import { toast } from 'react-toastify'

export default function ForgotPasswordPage() {
    const [isLoading, setIsLoading] = useState(false)
    const [emailSent, setEmailSent] = useState(false)
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/')
        }
    }, [isAuthenticated])

    const { formRef, submitButtonRef } = useFormState('forgot-password')

    const handleSubmit = async () => {
        setIsLoading(true)

        const state = ReactFormState.getInstance('forgot-password')

        if (!state.isValid) {
            toast.warning('Por favor, preencha o email corretamente.')
            setIsLoading(false)
            return
        }

        const { email } = state.values

        const response = await forgotPassword(email)

        if (response.success) {
            setEmailSent(true)
            toast.success('Email de recuperação enviado!')
        } else {
            toast.error(
                response.error ||
                    'Ocorreu um erro ao solicitar recuperação. Tente novamente.'
            )
        }

        setIsLoading(false)
    }

    if (emailSent) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MdCheckCircle className="text-green-600 text-2xl" />
                        </div>

                        <h1 className="text-2xl font-bold text-gray-900 mb-4">
                            Email Enviado!
                        </h1>

                        <p className="text-gray-600 mb-8">
                            Se o email existir em nossa base, você receberá um
                            link para redefinir sua senha. Verifique sua caixa
                            de entrada e spam.
                        </p>

                        <div className="space-y-4">
                            <Link
                                to="/login"
                                className="w-full btn btn-secondary"
                            >
                                Voltar ao Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {isLoading && <BackdropLoading visible={isLoading} />}

            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-2xl shadow-xl p-8">
                        <div className="text-center mb-8">
                            <h1 className="text-2xl font-bold text-gray-900 mb-2">
                                Esqueceu sua senha?
                            </h1>
                            <p className="text-gray-600">
                                Digite seu email e enviaremos um link para
                                redefinir sua senha.
                            </p>
                        </div>

                        <section className="space-y-6" ref={formRef}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    className="input input-bordered w-full"
                                    placeholder="Digite seu email"
                                    data-validators="required,email"
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                ref={submitButtonRef}
                                className="w-full btn btn-secondary"
                                disabled={isLoading}
                                onClick={handleSubmit}
                            >
                                {isLoading ? (
                                    <span className="loading loading-spinner loading-sm"></span>
                                ) : (
                                    'Enviar Link de Recuperação'
                                )}
                            </button>
                        </section>

                        <div className="mt-6 text-center">
                            <Link
                                to="/login"
                                className="text-sm text-brand-primary hover:text-brand-primary/80 font-medium"
                            >
                                ← Voltar ao Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
